/**
 * The merchant's display name: business name, then organization name, then store name.
 * Returns '' when none is set.
 */
export function pickStoreName({ businessName, organization, store } = {}) {
    const candidates = [businessName, organization?.name, store?.name];
    const resolved = candidates.map((value) => String(value || '').trim()).find(Boolean);
    // The seeded default is not a real business name — don't show it as one.
    if (!resolved || resolved === 'Restaurant Name') return '';
    return resolved;
}
